import React from "react";
import "./styles/AppAlert.css";

const AppAlert = ({ isShown, message }) => {
  if (!isShown) {
    return null;
  }
  return <div className="App--alert">{message}</div>;
};

export default AppAlert;

AppAlert.propTypes = {
  isShown: React.PropTypes.bool.isRequired,
  message: React.PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/modules/AppAlert.js